import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TOOLS } from "@/components/tools/ToolsGrid";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[var(--line)] mt-32"
      style={{ background: "var(--ink-2)" }}
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-10 py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <div className="brandmark mb-8">
            <span className="brandmark-rule" />
            <span className="brandmark-text" style={{ fontSize: "26px" }}>
              Corpora
            </span>
            <span className="brandmark-sub">{t("nav.consultants")}</span>
          </div>
          <h3 className="display text-4xl md:text-5xl text-[var(--bone)] leading-[1.05]">
            {t("footer.tagline1")}{" "}
            <span className="display-italic" style={{ color: "var(--pewter)" }}>
              {t("footer.tagline2")}
            </span>
          </h3>
          <p className="mt-6 text-[var(--mute)] max-w-md leading-relaxed">
            {t("footer.description")}
          </p>
        </div>

        <div className="md:col-span-2">
          <div className="overline mb-6">{t("footer.practiceTitle")}</div>
          <ul className="space-y-3 text-[var(--bone-2)]">
            <li><Link to="/services" className="link-under">{t("footer.links.legal")}</Link></li>
            <li><Link to="/services" className="link-under">{t("footer.links.corporate")}</Link></li>
            <li><Link to="/services" className="link-under">{t("footer.links.banking")}</Link></li>
            <li><Link to="/services" className="link-under">{t("footer.links.hq")}</Link></li>
            <li><Link to="/services" className="link-under">{t("footer.links.immigration")}</Link></li>
            <li><Link to="/services" className="link-under">{t("footer.links.tax")}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2" data-testid="footer-tools">
          <div className="overline mb-6">{t("tools.footerTitle")}</div>
          <ul className="space-y-3 text-[var(--bone-2)]">
            {TOOLS.map((tool) => (
              <li key={tool.id}>
                <Link to={tool.path} className="link-under" data-testid={`footer-tool-${tool.id}`}>{t(`tools.cards.${tool.id}.title`)}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="overline mb-6">{t("footer.firmTitle")}</div>
          <ul className="space-y-3 text-[var(--bone-2)]">
            <li><Link to="/about" className="link-under">{t("footer.links.about")}</Link></li>
            <li><Link to="/insights" className="link-under">{t("footer.links.journal")}</Link></li>
            <li><Link to="/faq" className="link-under" data-testid="footer-faq-link">{t("nav.links.faq")}</Link></li>
            <li><Link to="/contact" className="link-under">{t("footer.links.contact")}</Link></li>
            <li><Link to="/admin/login" className="link-under" data-testid="footer-admin-link">{t("footer.links.admin")}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="overline mb-6">{t("footer.officeTitle")}</div>
          <address className="not-italic text-[var(--bone-2)] leading-relaxed">
            Ischyron, Kato Polemidia
            <br />
            4151, Limassol
            <br />
            Cyprus
          </address>
          <a
            href="mailto:info@corporaco.com"
            data-testid="footer-email"
            className="link-under mt-4 inline-block"
          >
            info@corporaco.com
          </a>
        </div>
      </div>

      <div className="border-t border-[var(--line)]">
        <div className="max-w-[1480px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-mono text-[10px] text-[var(--mute-2)] uppercase tracking-[0.28em]">
            © {new Date().getFullYear()} Corpora Consultants · {t("footer.rights")}
          </div>
          <div className="font-mono text-[10px] text-[var(--mute-2)] uppercase tracking-[0.28em]">
            {t("footer.regions")}
          </div>
        </div>
      </div>
    </footer>
  );
}
